/**
 *
 * @page 用户中心入口
 *
 **/

import React, { useEffect } from 'react';
import { Menu, Breadcrumb, Layout } from 'antd';
import {
    Switch,
    Route,
    Redirect,
    useLocation,
    useHistory,
    Link,
} from 'react-router-dom';
import OrderDetail from '&/pages/order-manage/OrderDetail';
// import IntelligentDesign from '&/pages/order-manage/MemberOrder';
import CloudServices from '&/pages/order-manage/ServiceOrder';
import RoleAuthority from '&/pages/team-management/RoleAuthority';
import InspirationList from '&/pages/user-center/InspirationList';
import HouseType from '&/pages/my-collection/HouseType';
import CollectModel from '&/pages/my-collection/CollectModel';
import ModelList from '&/pages/my-collection/ModelList';
import MaterialDetail from '&/pages/my-collection/MaterialDetail';
import DecorationDetail from '&/pages/user-center/DecorationDetail';
import InteractiveMsg from './InteractiveMsg/index';
import ManagerPage from './DataBoard/ManagerPage';
import AdministratorPage from './DataBoard/AdministratorPage';
import ProjectStatusList from './DataBoard/ProjectStatusList';
import ProjectSatisfactionList from './DataBoard/ProjectSatisfactionList';
import StageSatisfactionList from './DataBoard/StageSatisfactionList';
import InspectionList from './DataBoard/InspectionList';
import AbnormalList from './DataBoard/AbnormalList';
import BacklogList from './DataBoard/BacklogList';
import CorporateMembership from './CorporateMembership';
import EnterpriseDecoration from './EnterpriseDecoration/index';
import FloorPlanDesign from '&/pages/floor-plan-design';
import FloorPlanEdit from '&/pages/floor-plan-design/edit';
import SystemMsg from './SystemMsg';
import { useStoreState } from '&/utils/customHooks';
import { setFold } from '&/api/personCenter/setting';
import { getManegers } from '@/api/personCenter/dataBoard';
import UploadMaterial from '&/pages/resource-lib/UploadMaterial';
import UploadModel from '&/pages/resource-lib/UploadModel';
import UploadLine from '&/pages/resource-lib/UploadLine';
import MaterialList from './MaterialList';
import ProxyOrder from '&/pages/order-manage/proxyOrder';

import './index.scss';

const PAGES = require.context('./', true, /\.js$/);
const COMPONENTS = {};
for (const PATH of PAGES.keys()) {
    if (PATH === './index.js') continue;
    COMPONENTS[PATH.replace(/^\.\/(.*)\.\w+$/, '$1')] = PAGES(PATH).default;
}

function UserCenter() {
    const appStore = useStoreState('appStore');

    const { organization = {}, userInfo } = appStore;

    const [isNotManager, setIsNotManagerId] = useState(false); //  有ID代表 当前用户有项目经理角色
    const isEntVIP =
        userInfo.vipEntType === 'vip_ent_unite' &&
        userInfo.vipEntExpireFlag === 0; // 是有效的企业会员
    useEffect(() => {
        getManegers({
            roleId: 2, // 项目经理
        }).then(({ data }) => {
            setIsNotManagerId(
                !data.list.find(e => e.userId === userInfo.userId)
            );
        });
    }, []);
    const UPLOAD_CHILDREN = [
        {
            path: '/upload-model',
            component: UploadModel,
            label: intl.get('userCenter.batchUpload'),
        },
        {
            path: '/upload-material',
            component: UploadMaterial,
            label: intl.get('userCenter.batchUpload'),
        },
        {
            path: '/upload-line',
            component: UploadLine,
            label: intl.get('userCenter.batchUpload'),
        },
        {
            path: '/material-detail/:id',
            component: MaterialDetail,
            label: intl.get('userCenter.viewDetail'),
        },
    ];

    const SUB_ROUTERS = [
        {
            label: intl.get('userCenterSidebar.dataDashboard'),
            path: 'data-board',
            icon: 'icon-dashboard2',
            children: [
                {
                    path: '/user-center/administrator', // 全路径
                    component: AdministratorPage,
                    label: intl.get('userCenterSidebar.administrator'),
                    isMenu: true, // 是否在侧边栏菜单里显示路由
                    isHide:
                        organization.roleFlag !== 'admin' &&
                        organization.example !== 0, // 是否加载路由
                    children: [
                        {
                            path: '/status-list', // 全路径
                            component: ProjectStatusList,
                            label: intl.get(
                                'dataBoard.projectStatusStatistics'
                            ),
                        },
                        {
                            path: '/satisfaction-list',
                            component: ProjectSatisfactionList,
                            label: '项目满意度统计',
                        },
                        {
                            path: '/stage-satisfaction',
                            component: StageSatisfactionList,
                            label: '阶段满意度统计',
                        },
                        {
                            path: '/inspection-list',
                            component: InspectionList,
                            label: '巡检质量统计',
                        },
                        {
                            path: '/abnormal-list',
                            component: AbnormalList,
                            label: '巡检异常统计',
                        },
                        {
                            path: '/backlog-list',
                            component: BacklogList,
                            label: '待办异常统计',
                        },
                    ],
                },
                {
                    path: '/user-center/manager', // 全路ProjectList径
                    component: ManagerPage,
                    label: intl.get('baseComponents.baseInfo.projectManager'),
                    isMenu: true, // 是否在侧边栏菜单里显示路由
                    isHide: isNotManager && organization.example !== 0,
                    children: [
                        {
                            path: '/status-list', // 全路径
                            component: ProjectStatusList,
                            label: intl.get(
                                'dataBoard.projectStatusStatistics'
                            ),
                        },
                        {
                            path: '/satisfaction-list', // 全路径
                            component: ProjectSatisfactionList,
                            label: '项目满意度统计',
                        },
                        {
                            path: '/stage-satisfaction',
                            component: StageSatisfactionList,
                            label: '阶段满意度统计',
                        },
                        {
                            path: '/inspection-list',
                            component: InspectionList,
                            label: '巡检质量统计',
                        },
                        {
                            path: '/abnormal-list',
                            component: AbnormalList,
                            label: '巡检异常统计',
                        },
                        {
                            path: '/backlog-list',
                            component: BacklogList,
                            label: '待办异常统计',
                        },
                    ],
                },
            ],
            // isHide:true
        },
        {
            label: intl.get('userCenter.decorationScheme'),
            path: 'schemeManagement',
            icon: 'icon-Floor-Plan-Edit-copy',
            children: [
                {
                    path: '/user-center/decoration-scheme', // 全路径
                    component: COMPONENTS.DecorationScheme,
                    label: intl.get('userCenter.myScheme'),
                    isMenu: true, // 是否在侧边栏菜单里显示路由
                    children: [
                        //   不在侧边菜单里显示路由，但是进入页面会高亮父路由
                        {
                            path: '/decoration-design/:id', // 子路径
                            component: DecorationDetail,
                            label: intl.get('userCenter.planDetails'),
                        },
                    ],
                },
                {
                    path: '/user-center/enterprise-decoration',
                    component: EnterpriseDecoration,
                    isHide:
                        !isEntVIP ||
                        (organization.roleFlag !== 'admin' &&
                            userInfo.authDesign !== 0), // 非管理员且无设计权益
                    label: intl.get('userCenterSidebar.enterpriseDecoration'),
                    isMenu: true,
                    children: [
                        {
                            path: '/decoration-design/:id',
                            component: DecorationDetail,
                            label: intl.get('userCenter.planDetails'),
                        },
                    ],
                },
                {
                    path: '/user-center/floor-plan-scheme',
                    component: FloorPlanDesign,
                    label: '平面图方案',
                    isMenu: true,
                    children: [
                        {
                            path: '/detail/:id', // 子路径
                            component: FloorPlanEdit,
                            label: '编辑方案',
                        },
                        {
                            path: '/add', // 子路径
                            component: FloorPlanEdit,
                            label: '方案上传',
                        },
                    ],
                },
                {
                    path: '/user-center/inspiration-list',
                    component: InspirationList,
                    label: intl.get('userCenterSidebar.inspirationList'),
                    isMenu: true,
                    children: [],
                },
            ],
        },
        {
            label: intl.get('userCenter.projectSpace'),
            path: 'scheme',
            icon: 'icon-Icon-Project',
            children: [
                {
                    path: '/user-center/project-space',
                    component: COMPONENTS.ProjectManage,
                    label: intl.get('userCenter.projectSpace'),
                    isMenu: true,
                    children: [
                        {
                            // path: '/detail',
                            // component: ProjectDetail,
                            path: '/project-detail',
                            component: () => (
                                <div>{intl.get('userCenterSidebar.tbd')}</div>
                            ),
                            label: intl.get('projectSpace.projectDetail'),
                        },
                        {
                            path: '/scheme-detail',
                            component: COMPONENTS.SchemeDetail,
                            label: intl.get('projectSpace.schemeDetail'),
                        },
                    ],
                },
            ],
        },
        {
            label: intl.get('userCenter.myCollect'),
            path: 'collect',
            icon: 'icon-favorites',
            children: [
                {
                    path: '/user-center/collect-house-type',
                    component: HouseType,
                    label: intl.get('userCenter.collectHousetype'),
                    isMenu: true,
                },
                {
                    path: '/user-center/collect-model',
                    component: CollectModel,
                    label: intl.get('userCenter.collectModel'),
                    isMenu: true,
                    children: [
                        {
                            path: '/model-list',
                            component: ModelList,
                            label: intl.get('userCenter.collectList'),
                        },
                        {
                            path: '/material-detail/:id',
                            component: MaterialDetail,
                            label: intl.get('userCenter.viewDetail'),
                        },
                    ],
                },
                /* {
                    path: '/user-center/collect-scheme',
                    component: CollectScheme,
                    label: intl.get('userCenter.collectScheme'),
                    isMenu: true,
                }, */
            ],
        },
        {
            path: 'repository',
            label: intl.get('userCenter.repository'),
            icon: 'icon-Icon-Light',
            children: [
                {
                    path: '/user-center/enterprise-material',
                    component: MaterialList,
                    label: intl.get('userCenterSidebar.enterpriseMaterial'),
                    isMenu: true,
                    children: UPLOAD_CHILDREN,
                },
                {
                    path: '/user-center/personal-material',
                    component: MaterialList,
                    label: intl.get('userCenterSidebar.personalMaterial'),
                    isMenu: true,
                    children: UPLOAD_CHILDREN,
                },
            ],
        },
        {
            label: intl.get('userCenterSidebar.organization'),
            path: 'organization',
            icon: 'icon-Org',
            children: [
                {
                    path: '/user-center/organization',
                    component: COMPONENTS.Organization,
                    label: intl.get('userCenterSidebar.organization'),
                    isMenu: true,
                },
                {
                    path: '/user-center/role-authority',
                    component: RoleAuthority,
                    label: intl.get('team.roleAuthority'),
                    isMenu: true,
                    isHide:
                        organization.roleFlag !== 'admin' &&
                        organization.example !== 0, // 非管理员且当前非示例组织
                },
            ],
        },
        {
            label: intl.get('userCenter.expenseCenter'),
            path: 'order',
            icon: 'icon-Clipboard',
            children: [
                {
                    path: '/user-center/corporate-membership',
                    component: CorporateMembership,
                    label: intl.get('userCenter.corporateMembership'),
                    isMenu: true,
                    children: [
                        {
                            path: '/order-detail',
                            component: () => (
                                <OrderDetail
                                    title={intl.get(
                                        'userCenter.corporateMembershipDetail'
                                    )}
                                />
                            ),
                            label: intl.get('userCenter.orderDetail'),
                        },
                    ],
                },
                {
                    path: '/user-center/cloud-services',
                    component: CloudServices,
                    label: intl.get('userCenter.cloudServicesOrder'),
                    isMenu: true,
                    children: [
                        {
                            path: '/order-detail',
                            component: () => (
                                <OrderDetail
                                    title={intl.get(
                                        'userCenter.cloudOrderDetail'
                                    )}
                                />
                            ),
                            label: intl.get('userCenter.orderDetail'),
                        },
                    ],
                },
                {
                    path: '/user-center/proxy-orders',
                    component: ProxyOrder,
                    label: '户型代画订单',
                    isMenu: true,
                    children: [
                        {
                            path: '/order-detail',
                            component: () => (
                                <OrderDetail title="户型代画订单详情" />
                            ),
                            label: intl.get('userCenter.orderDetail'),
                        },
                    ],
                },
            ],
        },
        {
            label: intl.get('userCenterSidebar.message'),
            path: 'message',
            icon: 'icon-bell',
            children: [
                {
                    path: '/user-center/interactive-message',
                    component: InteractiveMsg,
                    label: intl.get('userCenter.interactiveMsg'),
                    isMenu: true,
                },
                {
                    path: '/user-center/steward-center',
                    component: require('./StewardCenter/index').default,
                    label: intl.get('message.stewardMessage'),
                    isMenu: true,
                    isHide:
                        !['admin', 'housekeeper'].includes(
                            organization.roleFlag
                        ) && organization.example !== 0, // 管家和管理员加载路由
                },
                {
                    path: '/user-center/system-message',
                    component: SystemMsg,
                    label: intl.get('userCenter.systemMsg'),
                    isMenu: true,
                },
            ],
        },
        {
            label: intl.get('userCenterSidebar.setting'),
            path: 'setting',
            icon: 'icon-cog',
            children: [
                {
                    path: '/user-center/account-setting',
                    component: COMPONENTS.AccountInfo,
                    label: intl.get('userCenterSidebar.accountSetting'),
                    isMenu: true,
                },
                // {
                //     path: '/user-center/company-setting',
                //     component: COMPONENTS.ProjectManage,
                //     label: '企业信息',
                //     isMenu: true,
                // },
                {
                    path: '/user-center/login-setting',
                    component: COMPONENTS.LogoSettings,
                    label: intl.get('userCenterSidebar.logoSetting'),
                    isMenu: true,
                    isHide:
                        (organization.roleFlag !== 'admin' ||
                            organization.branchId) &&
                        organization.example !== 0,
                },
                {
                    path: '/user-center/company-setting',
                    component: COMPONENTS.EnterpriseInfo,
                    label: intl.get('userCenterSidebar.enterpriseInformation'),
                    isMenu: true,
                    isHide:
                        !['admin'].includes(organization.roleFlag) &&
                        organization.example !== 0, // 管家和管理员加载路由
                },
                {
                    path: '/user-center/template-setting',
                    component: COMPONENTS.TemplateSettings,
                    label: intl.get('userCenterSidebar.templateSetting'),
                    isMenu: true,
                },
            ],
        },
    ];

    const SIDE_BAR = [];

    for (const p of SUB_ROUTERS) {
        if (p.isHide) continue;
        SIDE_BAR.push({
            ...p,
            children: p.children.filter(c => c.isMenu && !c.isHide),
        });
    }

    // 判断当前页面是否显示二级路由
    const { pathname } = useLocation();
    const [activeKeys, setActiveKeys] = useState([]);

    // 菜单自动匹配高亮
    useEffect(() => {
        const pathArr = pathname.split('/');
        const match = [`/${pathArr[1]}/${pathArr[2]}`];
        setActiveKeys(match);
    }, [pathname]);

    const history = useHistory();
    const DEFAUT_ROUTER = SUB_ROUTERS.find(e =>
        e.children.some(ce => pathname.includes(ce.path))
    );

    const DEFAULT_OPEN = [DEFAUT_ROUTER?.path || 'scheme'];
    const DEFAULT_PATH = '/user-center/project-space';
    const { SubMenu, Item } = Menu;
    const [breadcrumb, setBreadcrumb] = useState(); // 自定义面包屑最后一个
    const ROUTER_LIST = SUB_ROUTERS.map(p => {
        let res = [];
        if (p.isHide) return res;
        if (p.component) {
            res = [
                <Route
                    exact
                    path={p.path}
                    render={props => {
                        return (
                            <>
                                <Breadcrumb>
                                    <Breadcrumb.Item>{p.label}</Breadcrumb.Item>
                                </Breadcrumb>
                                <p.component {...props} />
                            </>
                        );
                    }}
                />,
                ...res,
            ];
        } else {
            res = p.children.map((e, i) => {
                if (e.isHide) return null;
                return [
                    <Route
                        exact
                        key={i}
                        path={e.path}
                        render={props => {
                            return (
                                <>
                                    <Breadcrumb>
                                        <Breadcrumb.Item>
                                            {p.label}
                                        </Breadcrumb.Item>
                                        <Breadcrumb.Item>
                                            <Link to={e.path}>{e.label}</Link>
                                        </Breadcrumb.Item>
                                    </Breadcrumb>

                                    <e.component {...props} />
                                </>
                            );
                        }}
                    />,
                    e.children &&
                        e.children.map((ce, ci) => (
                            <Route
                                exact
                                key={ci}
                                path={e.path + ce.path}
                                render={props => {
                                    return (
                                        <>
                                            <Breadcrumb>
                                                <Breadcrumb.Item>
                                                    {p.label}
                                                </Breadcrumb.Item>
                                                <Breadcrumb.Item>
                                                    <Link to={e.path}>
                                                        {e.label}
                                                    </Link>
                                                </Breadcrumb.Item>

                                                {Array.isArray(breadcrumb) ? (
                                                    breadcrumb.map(
                                                        (el, idx) => {
                                                            return (
                                                                <Breadcrumb.Item
                                                                    key={idx}>
                                                                    {el}
                                                                </Breadcrumb.Item>
                                                            );
                                                        }
                                                    )
                                                ) : (
                                                    <Breadcrumb.Item>
                                                        {breadcrumb || ce.label}
                                                    </Breadcrumb.Item>
                                                )}
                                            </Breadcrumb>
                                            <ce.component
                                                {...props}
                                                setBreadcrumb={setBreadcrumb}
                                            />
                                        </>
                                    );
                                }}
                            />
                        )),
                ];
            });
        }
        return res;
    });

    const [collapsed, setCollapsed] = useState(!!organization.fold);
    const toggleCollapsed = () => {
        setCollapsed(!collapsed);
        let fold = !collapsed ? 1 : 0;
        userInfo.enterpriseSelects = userInfo.enterpriseSelects.map(v => {
            if (
                v.branchId === organization.branchId &&
                v.enterpriseId === organization.enterpriseId
            ) {
                v.fold = fold;
                return v;
            } else {
                return v;
            }
        });
        appStore.setUserInfo({ ...userInfo });
        appStore.setOrganization({ ...organization, fold });
        setFold({ menuFold: fold });
    };

    return (
        <Layout className="user-center">
            <Layout.Sider
                width={160}
                collapsedWidth={`${78 / 16}rem`}
                trigger={null}
                className="aside-menu"
                collapsible
                collapsed={collapsed}>
                <Menu
                    selectedKeys={activeKeys}
                    defaultOpenKeys={DEFAULT_OPEN}
                    triggerSubMenuAction="click"
                    mode="inline"
                    onClick={e => history.push(e.key)}>
                    {SIDE_BAR.map(p => (
                        <React.Fragment key={p.path}>
                            {p.component && (
                                <Item
                                    key={p.path}
                                    title={p.label}
                                    icon={<i className={`filled ${p.icon}`} />}>
                                    {p.label}
                                </Item>
                            )}

                            {!!p.children.length && (
                                <SubMenu
                                    key={p.path}
                                    popupClassName="app-sider-menu"
                                    icon={<i className={`filled ${p.icon}`} />}
                                    title={p.label}
                                    label={p.label}>
                                    {p.children.map(e => (
                                        <Item
                                            className="menu-item"
                                            key={e.path}>
                                            <i className="menu-icon-mins" />
                                            {e.label}
                                        </Item>
                                    ))}
                                </SubMenu>
                            )}
                        </React.Fragment>
                    ))}
                </Menu>
                <div
                    className="ant-layout-sider-trigger"
                    style={{ width: !collapsed ? '158px' : '66px' }}
                    onClick={toggleCollapsed}>
                    {collapsed ? (
                        <i className="outlined icon-Icon-Open" />
                    ) : (
                        <i className="outlined icon-Icon-Off" />
                    )}
                </div>
            </Layout.Sider>
            <Layout.Content className="user-center-content">
                <div id="custom-alert-wrap"></div>
                <Switch>
                    {ROUTER_LIST}
                    <Redirect to={DEFAULT_PATH} />
                </Switch>
            </Layout.Content>
        </Layout>
    );
}

export default UserCenter;
